import styled from 'styled-components';

export const Logo = styled.span<{ hasImage: boolean }>`
  color: var(--v3-text-color);
  ${props => !props.hasImage && 'background: var(--v3-black-6);'}
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Name = styled.span<{ whiteText?: boolean }>`
  line-height: 16px;
  height: 20px;
  display: flex;
  align-items: center;
  color: var(--v3-${props => (props.whiteText ? 'white' : 'text-color')});
`;

export const Container = styled.span<{
  reverse: boolean;
  size: 'sm' | 'md' | 'lg';
}>`
  flex-direction: ${props => (props.reverse ? 'row-reverse' : 'row')};
  display: inline-flex;
  align-items: center;
  flex: 1;
  ${props => {
    const dir = props.reverse ? 'right' : 'left';

    switch (props.size) {
      case 'lg':
        return `
        ${Logo} {
          width: 36px;
          height: 36px;
          font-size: 10px;
          line-height: 10px;
        }
        ${Name} {
          font-size: 16px;
          margin-${dir}: 11px;
          font-weight: 400;
        }
      `;
      case 'md':
        return `
        ${Logo} {
          width: 20px;
          min-width: 20px;
          height: 20px;
          font-size: 11px;
          line-height: 11px;
        }
        ${Name} {
          font-size: 12px;
          margin-${dir}: 8px;
          font-weight: 400;
        }
      `;
      case 'sm':
      default:
        return `
        ${Logo} {
          width: 18px;
          height: 18px;  
          font-size: 11px;
          line-height: 11px;
        }
        ${Name} {
          font-size: 12px;
          margin-${dir}: 4px;
        }
      `;
    }
  }};
`;
